(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fbs-faq"] && !Shopify.designMode) return;
  try {
    
  /* Theme editor: open an FAQ when its block is selected in the sidebar */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el && el.classList && el.classList.contains('fbfaq__item')) el.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fbs-happy-ears"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-fbtr-dir]');
      if (!btn) return;
      var track = btn.closest('.fbtr__viewport').querySelector('.fbtr__track');
      var card = track.querySelector('.fbtr__card');
      var step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : 300;
      track.scrollBy({ left: step * Number(btn.getAttribute('data-fbtr-dir')), behavior: 'smooth' });
    });
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target.classList && e.target.classList.contains('fbtr__card')) {
        e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
